import React from "react";
import { useSelector } from "react-redux";
// mui components
import { Stack, Grid, Box } from "@mui/material";

// custom components
import Heading6 from "../../typography/heading-06";
import Body2 from "../../typography/body-02";

// helper utils
import { filterValue } from "../../../utils/filter-value";
import { convertCSTtoEST, convertUTCtoEst } from "../../../utils/timezone-offset";
// custom styles
import styles from "./index.module.scss";

// redux slice
import { selectUserDetails, selectSelectedOrganization } from "../../../features/auth/authSlice";
import { selectImpersonatedUser } from "../../../features/admin/impersonated-user/impersonatedUserSlice";

//utils
import {
	BROKER_ADMIN,
	LOAN_CHANNEL_CONSTANTS,
	TPO_SECONDARY,
} from "../../../utils/common-constants";
import {
	selectedUserWithAccessLevel,
	selectedUserWithLoanChannel,
	selectedUser,
} from "../../../utils/common-helpers";

const LockParametersCard = ({ loanData, fieldData, lockRequestedOn, lockStatus, pendingStatus }) => {

	// Get the expiration date value
	const expirationDateStr = convertCSTtoEST(filterValue(fieldData, "762"));

	const userDetails = useSelector(selectUserDetails);
	const impersonatedUser = useSelector(selectImpersonatedUser);
	const selectedOrganization = useSelector(selectSelectedOrganization);
	// Determine which color class to use
	
	let colorClass = "";
	if (expirationDateStr === "NA" || expirationDateStr === "") {
		colorClass = "na";
	} else if (Date.parse(expirationDateStr) > Date.parse(convertUTCtoEst(new Date()))) {
		colorClass = "before";
	} else {
		console.log("900000", (Date.parse(expirationDateStr), Date.parse(new Date())))
		colorClass = "expired";
	}

	return (
		<Stack
			direction="column"
			alignItems="flex-start"
			className={styles.cardContainer}
		>
			<Grid
				container
				className={styles.bottomContainer}
				columns={8}
				columnSpacing={4}
				rowSpacing={3}
			>
				<Grid item className={styles.detailContainer} xs={6} sm={5} md={3}>
					<Stack direction="column" className={styles.detailDiv}>
						<Stack direction="row">
						<Box sx={{ width: 160, flexShrink: 0 }}>
							<Heading6 text="Lock Status" fontType="semibold" />
						</Box>	
							<Body2
								text={lockStatus || "NA"}
								extraClass={styles.detailsValue}
							/>	
						</Stack>
					</Stack>
				</Grid>
				<Grid item className={styles.detailContainer} xs={6} sm={5} md={3}>
					<Stack direction="column" className={styles.detailDiv}>
						<Stack direction="row">
						
						</Stack>
					</Stack>
				</Grid>
				<Grid item className={styles.detailContainer} xs={6} sm={5} md={3}>
					<Stack direction="column" className={styles.detailDiv}>
						<Stack direction="row">
						<Box sx={{ width: 160, flexShrink: 0 }}>
							<Heading6 text="Pending Requests" fontType="semibold" />
						</Box>	
							<Body2
								text={pendingStatus || "NA"}
								extraClass={styles.detailsValue}
							/>	
						</Stack>
					</Stack>
				</Grid>
				<Grid item className={styles.detailContainer} xs={6} sm={5} md={3}>
					<Stack direction="column" className={styles.detailDiv}>
						<Stack direction="row">
						
						</Stack>
					</Stack>
				</Grid>
				
				<Grid item className={styles.detailContainer} xs={6} sm={5} md={3}>
					<Stack direction="column" className={styles.detailDiv}>
						<Stack direction="row">
						<Box sx={{ width: 160, flexShrink: 0 }}>
							<Heading6 text="Lock Requested Date" fontType="semibold" />
						</Box>	
							<Body2
								text={convertUTCtoEst(lockRequestedOn) || "NA"}
								extraClass={styles.detailsValue}
							/>	
						</Stack>
					</Stack>
				</Grid>
				
				<Grid item className={styles.detailContainer} xs={6} sm={5} md={3}>
					<Stack direction="column" className={styles.detailDiv}>
					{!(
							selectedUserWithLoanChannel(userDetails, impersonatedUser, selectedOrganization)
								?.loan_channel === LOAN_CHANNEL_CONSTANTS.NDC ||
							selectedUserWithLoanChannel(userDetails, impersonatedUser, selectedOrganization)
								?.loan_channel === LOAN_CHANNEL_CONSTANTS.CORR
						) ||
						selectedUserWithAccessLevel(userDetails, impersonatedUser)
							?.access_level === TPO_SECONDARY || 
						selectedUserWithAccessLevel(userDetails, impersonatedUser)
							?.access_level === BROKER_ADMIN ? (<Stack direction="row">
								<Box sx={{ width: 160, flexShrink: 0 }}>
									<Heading6 text="Base Buy Price" fontType="semibold" />
								</Box>	
						
								<Body2
									text={filterValue(fieldData, "761") !== "" ? `${Number(filterValue(fieldData, "2161")).toFixed(3)}` : `${Number(filterValue(fieldData, "2101")).toFixed(3)}`}
									extraClass={styles.detailsValue}
								/>
							</Stack>):null}
					</Stack>
				</Grid>
				<Grid item className={styles.detailContainer} xs={6} sm={5} md={3}>
					<Stack direction="column" className={styles.detailDiv}>
						<Stack direction="row">
						<Box sx={{ width: 160, flexShrink: 0 }}>
							<Heading6 text="Lock Date" fontType="semibold" />
						</Box>
							<Body2
								text={convertCSTtoEST(filterValue(fieldData, "761")) || "NA"}
								extraClass={styles.detailsValue}
							/>
						</Stack>
					</Stack>
				</Grid>
				<Grid item className={styles.detailContainer} xs={6} sm={5} md={3}>
					<Stack direction="column" className={styles.detailDiv}>
					{!(
							selectedUserWithLoanChannel(userDetails, impersonatedUser, selectedOrganization)
								?.loan_channel === LOAN_CHANNEL_CONSTANTS.NDC ||
							selectedUserWithLoanChannel(userDetails, impersonatedUser, selectedOrganization)
								?.loan_channel === LOAN_CHANNEL_CONSTANTS.CORR
						) ||
						selectedUserWithAccessLevel(userDetails, impersonatedUser)
							?.access_level === TPO_SECONDARY || 
						selectedUserWithAccessLevel(userDetails, impersonatedUser)
							?.access_level === BROKER_ADMIN ? (<Stack direction="row">
					
							<Box sx={{ width: 160, flexShrink: 0 }}>
							<Heading6 text="Total Price Adjustment" fontType="semibold" />
							</Box>
					
							<Body2
							
								text={filterValue(fieldData, "761") !== "" ? `${Number(filterValue(fieldData, "2202")).toFixed(3)}` : `${Number(filterValue(fieldData, "2142")).toFixed(3)}`}
								extraClass={styles.detailsValue}
							/>
						</Stack>):null}
					</Stack>
				</Grid>

				<Grid item className={styles.detailContainer} xs={6} sm={5} md={3}>
					<Stack direction="column" className={styles.detailDiv}>
						<Stack direction="row">
							<Box sx={{ width: 160, flexShrink: 0 }}>
							<Heading6 text="Lock Expiration Date" fontType="semibold" />
							</Box>
							<Body2
								text={filterValue(fieldData, "761") !== "" ? expirationDateStr : "NA" }
								extraClass={`${styles.detailsValue} ${styles[colorClass]}`}
							/>
						</Stack>
					</Stack>
				</Grid>
				<Grid item className={styles.detailContainer} xs={6} sm={5} md={3}>
					<Stack direction="column" className={styles.detailDiv}>
					{!(
							selectedUserWithLoanChannel(userDetails, impersonatedUser, selectedOrganization)
								?.loan_channel === LOAN_CHANNEL_CONSTANTS.NDC ||
							selectedUserWithLoanChannel(userDetails, impersonatedUser, selectedOrganization)
								?.loan_channel === LOAN_CHANNEL_CONSTANTS.CORR
						) ||
						selectedUserWithAccessLevel(userDetails, impersonatedUser)
							?.access_level === TPO_SECONDARY || 
						selectedUserWithAccessLevel(userDetails, impersonatedUser)
							?.access_level === BROKER_ADMIN ? (<Stack direction="row">
							<Box sx={{ width: 160, flexShrink: 0 }}>
							<Heading6 text="Net Buy Price" fontType="semibold" />
							</Box>
				
							<Body2
								
								text={filterValue(fieldData, "761") !== "" ? `${Number(filterValue(fieldData, "2203")).toFixed(3)}` :  `${Number(filterValue(fieldData, "2143")).toFixed(3)}`}
								extraClass={styles.detailsValue}
							/>
						</Stack>):null}
					</Stack>
				</Grid>

				<Grid item className={styles.detailContainer} xs={6} sm={5} md={3}>
					<Stack direction="column" className={styles.detailDiv}>
						<Stack direction="row">
						<Box sx={{ width: 160, flexShrink: 0 }}>
							<Heading6 text="Lock Last Updated" fontType="semibold" />
							</Box>
							<Body2
								text={(convertCSTtoEST(filterValue(fieldData, "CX.OBTIME"),{ includeTime: true, use12Hour: true, appendET: true }) || "NA")}
								extraClass={styles.detailsValue}
							/>
						</Stack>
					</Stack>
				</Grid>
				<Grid item className={styles.detailContainer} xs={6} sm={5} md={3}>
					<Stack direction="column" className={styles.detailDiv}>
					{!(
							selectedUserWithLoanChannel(userDetails, impersonatedUser, selectedOrganization)
								?.loan_channel === LOAN_CHANNEL_CONSTANTS.NDC ||
							selectedUserWithLoanChannel(userDetails, impersonatedUser, selectedOrganization)
								?.loan_channel === LOAN_CHANNEL_CONSTANTS.CORR
						) ||
						selectedUserWithAccessLevel(userDetails, impersonatedUser)
							?.access_level === TPO_SECONDARY || 
						selectedUserWithAccessLevel(userDetails, impersonatedUser)
							?.access_level === BROKER_ADMIN ? (
						<Stack direction="row">
							<Box sx={{ width: 160, flexShrink: 0 }}>
								<Heading6 text="Net Buy Rate" fontType="semibold" />
							</Box>
						
							<Body2
								text={filterValue(fieldData, "761") !== "" ? `${Number(filterValue(fieldData, "2160")).toFixed(3)}%` : `${Number(filterValue(fieldData, "2100")).toFixed(3)}%`}
								extraClass={styles.detailsValue}
							/>
						</Stack>):null}
					</Stack>
				</Grid>
			</Grid>
		</Stack>
	);
};

export default LockParametersCard;
